import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPortList(params = {}) {
  return request({
    url: URL.mdm.basicData.seaPort + '/portList',
    method: 'get',
    params: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 1000,
      likeName: params.likeName || ''
    }
  })
}
